import { Controller } from "stimulus"

export default class extends Controller {
  static values = { id: String }

  connect() {
    this.container = document.getElementById(this.idValue)
    this.toggleInputFields(this.container.classList.contains('hidden'))
  }

  toggle() {
    this.container.classList.toggle('hidden')
    this.toggleInputFields(this.container.classList.contains('hidden'))
  }

  toggleInputFields(disabled) {
    let inputs = this.container.querySelectorAll('input, select, textarea')
    inputs.forEach((input) => {
      input.disabled = disabled
    })
  }
}
